import { render, staticRenderFns } from "./RightSpecialty.vue?vue&type=template&id=548e9e40&scoped=true&"
import script from "./RightSpecialty.vue?vue&type=script&lang=js&"
export * from "./RightSpecialty.vue?vue&type=script&lang=js&"
import style0 from "./RightSpecialty.vue?vue&type=style&index=0&id=548e9e40&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548e9e40",
  null
  
)

export default component.exports